import styled from 'styled-components';
import DefaultSwitch from 'components/Form/Switch';
import { Body, Caption } from 'components/Typography';
import DefaultAvatar from 'components/Avatar';
import Alarm from 'assets/icons/alarm.svg?react';

const ROW_HEIGHT = '4.5rem';

// TODO: TFR-44 move to container group
export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 2rem;
`;

// TODO: TFR-45:Avatar make unique name or do not export
export const Avatar = styled(DefaultAvatar)`
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
`;

// TODO: TFR-44 move to containers group. Just exact as in BrandStatus
export const RightSection = styled.div`
  padding-right: 2rem;
  width: 100%;
  height: ${ROW_HEIGHT};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RightSectionBorder = styled(RightSection)`
  border-top: 0.0625rem solid ${({ theme }) => theme.colors.gray2};
`;

export const IntegrationName = styled(Body)`
  flex: 1rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Switch = styled(DefaultSwitch)``;

export const BusyModeInfo = styled.div`
  padding: 0.5rem 3rem;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.navyGreen};
`;

export const BusyUntil = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-bottom: 0.5rem;
`;

export const BusyCaption = styled(Caption)``;

export const AlarmIcon = styled(Alarm)``;
